import { ProfilerAction } from '$logic/profiler/types'
import hostConfig from '$config/frontend'

const convertPercentageToModuloThreshold = (percentage: number) =>
  Math.floor(percentage / 10)

export function shouldProfileUserPerformance(userId: string) {
  const userCoverage = hostConfig.PERFORMANCE_PROFILER_USER_COVERAGE || 0
  if (!userCoverage) return false

  let hash = 5381
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < userId.length; i++)
    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) + hash + userId.charCodeAt(i) // hash * 33 + c

  // eslint-disable-next-line no-bitwise
  const hashValue = hash >>> 0 // Ensure unsigned 32-bit integer
  return hashValue % 10 < convertPercentageToModuloThreshold(userCoverage)
}

export const ignoreUserCoverageActions: ProfilerAction[] = [
  ProfilerAction.UPDATE_APP,
  ProfilerAction.SYNC_ROOMS,
]
